import React, { FC } from 'react';

import { GridColumn, Label, cn, useMobile } from 'Modules/ui2';
import { useTranslation } from 'Modules/core/i18n';

import Check from '../check.sprite.svg';
import NonCheck from './nonCheck.sprite.svg';
import styles from './index.module.scss';


type ProffitProps = {
    value: string;
    isSelected: boolean;
}

export const Proffit: FC<ProffitProps> = ({ value, isSelected }) => {
    const { t } = useTranslation('registrationForm');
    const isMobile = useMobile();
    return (
        <div
            key={value}
            className={cn(
                styles.item,
                isSelected && styles.selected,
            )}
        >
            <Label component='div' textSize='18' weight={!isMobile ? 'medium' : 'regular'}>
                {t(`rate.proffits.${value}`)}
            </Label>
            {isSelected ? <Check /> : <NonCheck />}
        </div>
    );
};

const proffits = [
    'fast',
    'verified',
    'registers',
    'discounting',
    'individual',
];

type ProffitsProps = {
    selected: number[];
    onlySelected?: boolean;
}

export const Proffits: FC<ProffitsProps> = ({ selected, onlySelected }) => (
    <GridColumn size={6} className={styles.container}>
        {(onlySelected ? selected.map(index => proffits[index]) : proffits).map((value, index) => (
            <Proffit
                key={value}
                value={value}
                isSelected={onlySelected || selected.includes(index)}
            />
        ))}
    </GridColumn>
);
